(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["explore-collection-clean"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isMobileViewport = window.matchMedia('(max-width: 749px)');

    const updateArrowState = (section) => {
      if (!section) return;
      const slider = section.querySelector('[data-slider]');
      const prevBtn = section.querySelector('[data-prev]');
      const nextBtn = section.querySelector('[data-next]');
      if (!slider || !prevBtn || !nextBtn) return;

      const maxScrollLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const atStart = slider.scrollLeft <= 1;
      const atEnd = slider.scrollLeft >= maxScrollLeft - 1;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    const getStep = (slider) => {
      const card = slider.querySelector('.explore-clean__card');
      if (!card) return 320;
      const gap = parseInt(getComputedStyle(slider).gap, 10) || 16;
      return card.offsetWidth + gap;
    };

    window.ExploreCleanScroll = (triggerEl, direction) => {
      if (!triggerEl) return;
      const section = triggerEl.closest('[data-explore-clean]');
      if (!section) return;
      const slider = section.querySelector('[data-slider]');
      if (!slider) return;

      const step = getStep(slider);
      const move = direction === 'next' ? step : -step;
      const targetLeft = slider.scrollLeft + move;

      if (typeof slider.scrollTo === 'function') {
        slider.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
      } else {
        slider.scrollLeft = targetLeft;
      }

      requestAnimationFrame(() => updateArrowState(section));
      setTimeout(() => updateArrowState(section), 260);
    };

    const isTouchPrimary =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: none) and (pointer: coarse)').matches;

    const initDragForRail = (slider) => {
      if (!slider || slider.dataset.dragInit === 'true') return;
      slider.dataset.dragInit = 'true';

      const dragThreshold = 6;
      let isPointerDown = false;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let activeTouchId = null;
      let dragDistance = 0;
      let suppressClickUntil = 0;

      const getTouchById = (touchList, touchId) => {
        for (let i = 0; i < touchList.length; i += 1) {
          if (touchList[i].identifier === touchId) return touchList[i];
        }
        return null;
      };

      const startDrag = (clientX) => {
        isPointerDown = true;
        isDragging = false;
        dragStartX = clientX;
        dragStartScrollLeft = slider.scrollLeft;
        dragDistance = 0;
      };

      const moveDrag = (clientX, event) => {
        if (!isPointerDown) return;
        const deltaX = clientX - dragStartX;
        dragDistance = Math.max(dragDistance, Math.abs(deltaX));

        if (!isDragging) {
          if (dragDistance < dragThreshold) return;
          isDragging = true;
          slider.classList.add('is-dragging');
          slider.style.scrollSnapType = 'none';
        }

        if (event && event.cancelable) event.preventDefault();
        slider.scrollLeft = dragStartScrollLeft - deltaX;
        updateArrowState(slider.closest('[data-explore-clean]'));
      };

      const endDrag = () => {
        if (!isPointerDown) return;

        if (isDragging) {
          slider.classList.remove('is-dragging');
          slider.style.scrollSnapType = '';
          if (dragDistance >= dragThreshold) suppressClickUntil = Date.now() + 260;
        }

        isPointerDown = false;
        isDragging = false;
        activeTouchId = null;
      };

      slider.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        if (event.target.closest('button, input, textarea, select, form')) return;
        event.preventDefault();
        startDrag(event.clientX);
      });

      window.addEventListener('mousemove', (event) => {
        moveDrag(event.clientX, event);
      });

      window.addEventListener('mouseup', () => {
        endDrag();
      });

      // On touch-primary devices we let the browser handle horizontal scrolling
      // natively — that gives true momentum/inertia and a smooth feel. The JS
      // drag handlers are only needed for mouse-driven dragging on desktop.
      if (!isTouchPrimary) {
        slider.addEventListener(
          'touchstart',
          (event) => {
            if (!event.changedTouches || !event.changedTouches.length) return;
            if (event.target.closest('button, input, textarea, select, form')) return;
            const touch = event.changedTouches[0];
            activeTouchId = touch.identifier;
            startDrag(touch.clientX);
          },
          { passive: false }
        );

        slider.addEventListener(
          'touchmove',
          (event) => {
            if (!isPointerDown || activeTouchId === null) return;
            const touch =
              getTouchById(event.changedTouches, activeTouchId) || getTouchById(event.touches, activeTouchId);
            if (!touch) return;
            moveDrag(touch.clientX, event);
          },
          { passive: false }
        );

        slider.addEventListener('touchend', (event) => {
          if (activeTouchId === null) return;
          const touch = getTouchById(event.changedTouches, activeTouchId);
          if (touch) endDrag();
        });

        slider.addEventListener('touchcancel', () => {
          endDrag();
        });
      }

      slider.addEventListener(
        'click',
        (event) => {
          if (Date.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      slider.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      slider.addEventListener('scroll', () => {
        updateArrowState(slider.closest('[data-explore-clean]'));
      });

      updateArrowState(slider.closest('[data-explore-clean]'));
    };

    const updateParallaxForSection = (section) => {
      if (!section) return;
      const mediaWrap = section.querySelector('[data-explore-clean-parallax]');
      const image = mediaWrap ? mediaWrap.querySelector('.explore-clean__image') : null;
      if (!mediaWrap || !image) return;

      if (prefersReducedMotion.matches || isMobileViewport.matches) {
        image.style.transform = '';
        return;
      }

      const viewportHeight = window.innerHeight || 1;
      const rect = mediaWrap.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
      const offset = progress * 220;
      image.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0) scale(1.1)`;
    };

    let parallaxTicking = false;
    const requestParallaxUpdate = () => {
      if (parallaxTicking) return;
      parallaxTicking = true;
      window.requestAnimationFrame(() => {
        parallaxTicking = false;
        document.querySelectorAll('[data-explore-clean]').forEach((section) => updateParallaxForSection(section));
      });
    };

    const initAllRails = (root = document) => {
      const rails = root.querySelectorAll('[data-explore-clean] [data-slider]');
      rails.forEach((rail) => initDragForRail(rail));
      const sections = root.querySelectorAll('[data-explore-clean]');
      sections.forEach((section) => {
        updateArrowState(section);
        updateParallaxForSection(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllRails());
    } else {
      initAllRails();
    }

    document.addEventListener('click', (event) => {
      const eventTarget = event.target;
      const targetEl =
        eventTarget instanceof Element
          ? eventTarget
          : eventTarget && eventTarget.parentElement
          ? eventTarget.parentElement
          : null;
      if (!targetEl) return;

      const arrow = targetEl.closest('[data-prev], [data-next]');
      if (!arrow) return;

      const section = arrow.closest('[data-explore-clean]');
      if (!section) return;

      const slider = section.querySelector('[data-slider]');
      if (!slider) return;

      event.preventDefault();
      window.ExploreCleanScroll(arrow, arrow.hasAttribute('data-next') ? 'next' : 'prev');
    });

    document.addEventListener('shopify:section:load', (event) => {
      initAllRails(event.target);
    });

    window.addEventListener('resize', () => {
      initAllRails();
    });

    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);
    prefersReducedMotion.addEventListener('change', requestParallaxUpdate);
    isMobileViewport.addEventListener('change', requestParallaxUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAllExploreSections = () => {
      document.querySelectorAll('.explore-section').forEach((sectionEl) => {
        initExploreCollectionSection(sectionEl);
      });
    };

    const initExploreCollectionSection = (root) => {
      let sectionRoot = null;
      if (root && root.matches && root.matches('.explore-section')) {
        sectionRoot = root;
      } else if (root && root.querySelector) {
        sectionRoot = root.querySelector('.explore-section');
      }
      if (!sectionRoot) return;
      if (sectionRoot.dataset.exploreInit === 'true') return;
      sectionRoot.dataset.exploreInit = 'true';

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      const slider = sectionRoot.querySelector('[data-slider]');
      if (slider) {
        const next = sectionRoot.querySelector('.explore-arrows .next');
        const prev = sectionRoot.querySelector('.explore-arrows .prev');

        const getScrollStep = () => {
          const card = slider.querySelector('.product-card');
          if (!card) return 384;
          const gap = parseInt(getComputedStyle(slider).gap, 10) || 24;
          return card.offsetWidth + gap;
        };

        if (next) {
          next.addEventListener('click', () => {
            const step = getScrollStep();
            slider.scrollBy({ left: step, behavior: 'auto' });
          });
        }

        if (prev) {
          prev.addEventListener('click', () => {
            const step = getScrollStep();
            slider.scrollBy({ left: -step, behavior: 'auto' });
          });
        }

        /* Horizontal drag (no scroll-linked tilt — that caused jitter with CSS transitions). */
          let isDragging = false;
          let dragStartX = 0;
          let dragStartScrollLeft = 0;
          let pointerId = null;
          let dragDistance = 0;
          let suppressClickUntil = 0;

          slider.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            /* Touch: native horizontal scroll only — pointer capture blocks vertical page scroll */
            if (event.pointerType === 'touch') return;
            if (event.target.closest('button, input, textarea, select')) return;
          /* Do not treat product PDP links as slider drag — avoids micro-move “suppress click” killing navigation. */
          if (event.target.closest('a.product-card__full-link')) return;

            isDragging = true;
            pointerId = event.pointerId;
            dragStartX = event.clientX;
            dragStartScrollLeft = slider.scrollLeft;
            dragDistance = 0;
            slider.classList.add('is-dragging');
            slider.setPointerCapture(pointerId);
          });

          slider.addEventListener('pointermove', (event) => {
            if (!isDragging || event.pointerId !== pointerId) return;

            const deltaX = event.clientX - dragStartX;
            dragDistance = Math.max(dragDistance, Math.abs(deltaX));
            slider.scrollLeft = dragStartScrollLeft - deltaX;
          });

          const endDrag = (event) => {
            if (!isDragging || event.pointerId !== pointerId) return;
            isDragging = false;
            slider.classList.remove('is-dragging');
            slider.releasePointerCapture(pointerId);
            pointerId = null;

            if (dragDistance > 6) {
              suppressClickUntil = Date.now() + 220;
            sectionRoot.dataset.exploreNavSuppressUntil = String(suppressClickUntil);
          } else {
            sectionRoot.dataset.exploreNavSuppressUntil = '';
            }
          };

          slider.addEventListener('pointerup', endDrag);
          slider.addEventListener('pointercancel', endDrag);

          slider.addEventListener(
            'click',
            (event) => {
            if (Date.now() > suppressClickUntil) return;
            /* After a horizontal drag, suppress the synthetic click — but never block real link navigation. */
            if (event.target.closest('a.product-card__full-link')) return;
                event.preventDefault();
                event.stopPropagation();
            },
            true
          );

        slider.addEventListener('dragstart', (event) => {
          event.preventDefault();
        });
      }

      const parallaxWrap = sectionRoot.querySelector('[data-explore-parallax]');
      const image = parallaxWrap?.querySelector('img');
      if (!parallaxWrap || !image) return;

      if (prefersReducedMotion || isMobile) return;

      let isTicking = false;

      const updateParallax = () => {
        isTicking = false;
        const viewportHeight = window.innerHeight || 1;
        const rect = parallaxWrap.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
        const offset = progress * 140;
        image.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0) scale(1.06)`;
      };

      const requestParallaxUpdate = () => {
        if (isTicking) return;
        isTicking = true;
        window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllExploreSections);
    } else {
      initAllExploreSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initExploreCollectionSection(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-on"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setFeaturedOnTravel() {
      document.querySelectorAll('.featured-on-wrap .featured-on').forEach(function (section) {
        var viewport = section.querySelector('.featured-on__viewport');
        var track = section.querySelector('.featured-on__logos');
        if (!viewport || !track) return;

        var travel = Math.max(0, track.scrollWidth - viewport.clientWidth);
        viewport.style.setProperty('--travel', travel + 'px');

        // Adjust duration based on distance (keeps speed consistent)
        var duration = Math.max(12, Math.min(40, travel / 60));
        track.style.animationDuration = duration + 's';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setFeaturedOnTravel);
    } else {
      setFeaturedOnTravel();
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(window.__featuredOnResizeTimer);
      window.__featuredOnResizeTimer = window.setTimeout(setFeaturedOnTravel, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parallaxVisuals = document.querySelectorAll('[data-footer-parallax]');
    const newsletterCards = document.querySelectorAll('[data-footer-newsletter-parallax]');
    if (!parallaxVisuals.length && !newsletterCards.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (prefersReducedMotion || isMobile) return;

    let isTicking = false;

    const updateParallax = () => {
      isTicking = false;
      const viewportHeight = window.innerHeight || 1;

      parallaxVisuals.forEach((visual) => {
        const rect = visual.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const speed = Number(visual.dataset.parallaxSpeed || 20);
        const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
        const offset = progress * speed * 1.6;
        const image = visual.querySelector('img');
        if (!image) return;

        image.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0) scale(1.2)`;
      });

      newsletterCards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
        const offset = progress * -70;
        card.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
      });
    };

    const requestParallaxUpdate = () => {
      if (isTicking) return;
      isTicking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);
    document.addEventListener('shopify:section:load', requestParallaxUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroMediaItems = document.querySelectorAll('[data-hero-parallax]');
    if (!heroMediaItems.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (prefersReducedMotion || isMobile) return;

    let isTicking = false;

    const updateParallax = () => {
      isTicking = false;
      const viewportHeight = window.innerHeight || 1;

      heroMediaItems.forEach((media) => {
        const rect = media.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
        const offset = progress * 120;
        media.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0) scale(1.12)`;
      });
    };

    const requestParallaxUpdate = () => {
      if (isTicking) return;
      isTicking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);
    document.addEventListener('shopify:section:load', requestParallaxUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cta-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-banner-parallax]');
    if (!sections.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (prefersReducedMotion || isMobile) return;

    let isTicking = false;

    const updateParallax = () => {
      isTicking = false;
      const viewportHeight = window.innerHeight || 1;

      sections.forEach((section) => {
        const bg = section.querySelector('[data-banner-bg]');
        if (!bg) return;

        const rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
        const offset = progress * 90;
        bg.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0) scale(1.05)`;
      });
    };

    const requestParallaxUpdate = () => {
      if (isTicking) return;
      isTicking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);
    document.addEventListener('shopify:section:load', requestParallaxUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (() => {
    const heroes = document.querySelectorAll('[data-article-hero-parallax]');
    if (!heroes.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (prefersReducedMotion || isMobile) return;

    let ticking = false;
    const updateParallax = () => {
      ticking = false;
      const viewportHeight = window.innerHeight || 1;

      heroes.forEach((hero) => {
        const media = hero.querySelector('[data-article-hero-media]');
        if (!media) return;

        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
        const offset = progress * 120;
        media.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0) scale(1.08)`;
      });
    };

    const requestParallaxUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    requestParallaxUpdate();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);
    document.addEventListener('shopify:section:load', requestParallaxUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  (() => {
    const getStep = (slider) => {
      const card = slider.querySelector('.collections-product-card');
      const gap = parseInt(getComputedStyle(slider).gap, 10) || 12;
      return (card ? card.offsetWidth : 300) + gap;
    };

    const scrollRow = (row, direction) => {
      if (!row) return;
      const slider = row.querySelector('[data-row-slider]');
      if (!slider) return;

      const delta = direction === 'next' ? getStep(slider) : -getStep(slider);
      const target = slider.scrollLeft + delta;
      const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const clampedTarget = Math.max(0, Math.min(target, maxLeft));

      if (typeof slider.scrollTo === 'function') {
        slider.scrollTo({ left: clampedTarget, behavior: 'smooth' });
      } else {
        slider.scrollLeft = clampedTarget;
      }

      requestAnimationFrame(() => updateArrows(row));
      setTimeout(() => updateArrows(row), 240);
    };

    window.CollectionsRowScroll = (trigger, direction) => {
      if (!trigger) return false;
      const row = trigger.closest('[data-collection-row]');
      if (!row) return false;
      scrollRow(row, direction === 'next' ? 'next' : 'prev');
      return false;
    };

    const updateArrows = (row) => {
      const slider = row.querySelector('[data-row-slider]');
      const prev = row.querySelector('[data-row-prev]');
      const next = row.querySelector('[data-row-next]');
      if (!slider || !prev || !next) return;

      const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
      const atStart = slider.scrollLeft <= 1;
      const atEnd = slider.scrollLeft >= maxLeft - 1;

      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    };

    const initRow = (row) => {
      if (!row) return;

      const slider = row.querySelector('[data-row-slider]');
      const prev = row.querySelector('[data-row-prev]');
      const next = row.querySelector('[data-row-next]');
      if (!slider || !prev || !next) return;

      if (row.dataset.sliderInit === 'true') {
        updateArrows(row);
        return;
      }

      row.dataset.sliderInit = 'true';

      const sectionRoot = row.closest('.collections-slider-list');
      const autoRotateEnabled =
        sectionRoot?.dataset.autoRotate === 'true' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const baseIntervalMs = Math.min(
        5000,
        Math.max(3000, parseInt(sectionRoot?.dataset.autoRotateMs || '4000', 10) || 4000),
      );

      let autoTimer = null;
      let autoPaused = false;

      const clearAutoTimer = () => {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      };

      const scheduleAutoRotate = () => {
        clearAutoTimer();
        if (!autoRotateEnabled) return;

        const tick = () => {
          if (autoPaused || document.hidden) return;
          const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
          if (maxLeft < 4) return;

          if (slider.scrollLeft >= maxLeft - 2) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            scrollRow(row, 'next');
          }
          setTimeout(() => updateArrows(row), 320);
        };

        autoTimer = window.setInterval(tick, baseIntervalMs);
      };

      const pauseAuto = () => {
        autoPaused = true;
      };

      const resumeAuto = () => {
        autoPaused = false;
      };

      prev.addEventListener('click', (event) => {
        event.preventDefault();
        scrollRow(row, 'prev');
        clearAutoTimer();
        scheduleAutoRotate();
      });

      next.addEventListener('click', (event) => {
        event.preventDefault();
        scrollRow(row, 'next');
        clearAutoTimer();
        scheduleAutoRotate();
      });

      slider.addEventListener('scroll', () => updateArrows(row));

      slider.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', () => updateArrows(row), { once: true });
        image.addEventListener('error', () => updateArrows(row), { once: true });
      });

      if (autoRotateEnabled) {
        row.addEventListener('pointerdown', () => {
          pauseAuto();
        });
        row.addEventListener('pointerup', () => {
          window.setTimeout(resumeAuto, 2000);
        });
        row.addEventListener('pointercancel', () => {
          window.setTimeout(resumeAuto, 2000);
        });

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          row.addEventListener('mouseenter', pauseAuto);
          row.addEventListener('mouseleave', resumeAuto);
        }

        const rowIndex = Array.from(document.querySelectorAll('[data-collection-row]')).indexOf(row);
        window.setTimeout(() => {
          const maxLeft = Math.max(0, slider.scrollWidth - slider.clientWidth);
          if (maxLeft >= 4) {
            scheduleAutoRotate();
          }
        }, 400 + rowIndex * 450);
      }

      updateArrows(row);
    };

    const initAllRows = () => {
      document.querySelectorAll('[data-collection-row]').forEach((row) => initRow(row));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllRows);
    } else {
      initAllRows();
    }

    window.addEventListener('load', initAllRows);
    window.addEventListener('resize', initAllRows);
    document.addEventListener('shopify:section:load', initAllRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-impact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-impact-parallax]');
    if (!sections.length) return;

    const shouldDisable = () => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobile = window.matchMedia('(max-width: 1024px)').matches;
      return reduced || mobile;
    };

    const reset = (section) => {
      section
        .querySelectorAll('[data-impact-heading], [data-impact-decoration], [data-impact-icon], [data-impact-text]')
        .forEach((el) => {
          el.style.transform = 'translate3d(0, 0, 0)';
        });
    };

    const updateSection = (section) => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || 1;
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
      const heading = section.querySelector('[data-impact-heading]');
      const decoration = section.querySelector('[data-impact-decoration]');
      const icon = section.querySelector('[data-impact-icon]');
      const texts = section.querySelectorAll('[data-impact-text]');

      if (heading) heading.style.transform = `translate3d(0, ${(progress * -52).toFixed(2)}px, 0)`;
      if (decoration) decoration.style.transform = `translate3d(0, ${(progress * 72).toFixed(2)}px, 0)`;
      if (icon) icon.style.transform = `translate3d(0, ${(progress * -36).toFixed(2)}px, 0)`;
      texts.forEach((text, index) => {
        const strength = index === 0 ? 32 : 44;
        text.style.transform = `translate3d(0, ${(progress * strength).toFixed(2)}px, 0)`;
      });
    };

    let ticking = false;
    const render = () => {
      ticking = false;
      sections.forEach((section) => {
        if (shouldDisable()) {
          reset(section);
          return;
        }
        updateSection(section);
      });
    };

    const requestRender = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    };

    requestRender();
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender);
    document.addEventListener('shopify:section:load', requestRender);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-promise"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-promise-parallax]');
    if (!sections.length) return;

    const shouldDisable = () => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobile = window.matchMedia('(max-width: 1024px)').matches;
      return reduced || mobile;
    };

    const reset = (section) => {
      section
        .querySelectorAll(
          '[data-promise-heading], [data-promise-decoration], [data-promise-icon], [data-promise-left], [data-promise-right]'
        )
        .forEach((el) => {
          el.style.transform = 'translate3d(0, 0, 0)';
        });
    };

    const updateSection = (section) => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || 1;
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      const progress = ((viewportHeight - rect.top) / (viewportHeight + rect.height)) * 2 - 1;
      const heading = section.querySelector('[data-promise-heading]');
      const decoration = section.querySelector('[data-promise-decoration]');
      const icon = section.querySelector('[data-promise-icon]');
      const left = section.querySelector('[data-promise-left]');
      const right = section.querySelector('[data-promise-right]');

      if (heading) heading.style.transform = `translate3d(0, ${(progress * -56).toFixed(2)}px, 0)`;
      if (decoration) decoration.style.transform = `translate3d(0, ${(progress * 84).toFixed(2)}px, 0)`;
      if (icon) icon.style.transform = `translate3d(0, ${(progress * -36).toFixed(2)}px, 0)`;
      if (left) left.style.transform = `translate3d(0, ${(progress * 34).toFixed(2)}px, 0)`;
      if (right) right.style.transform = `translate3d(0, ${(progress * 52).toFixed(2)}px, 0)`;
    };

    let ticking = false;
    const render = () => {
      ticking = false;
      sections.forEach((section) => {
        if (shouldDisable()) {
          reset(section);
          return;
        }
        updateSection(section);
      });
    };

    const requestRender = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    };

    requestRender();
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender);
    document.addEventListener('shopify:section:load', requestRender);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-cards-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__tathaParallaxV2State) {
      window.__tathaParallaxV2State = {
        bound: false,
        rafId: 0,
        items: [],
        desktopQuery: window.matchMedia('(min-width: 990px)'),
        reduceMotionQuery: window.matchMedia('(prefers-reduced-motion: reduce)'),
        readTargets() {
          const vh = window.innerHeight || 1;
          const isDesktop = this.desktopQuery.matches;
          const prefersReducedMotion = this.reduceMotionQuery.matches;

          this.items.forEach((item) => {
            const rect = item.section.getBoundingClientRect();
            if (!isDesktop || prefersReducedMotion || rect.bottom < 0 || rect.top > vh) {
              item.imageTarget = 0;
              item.cardTargets.fill(0);
              return;
            }

            const raw = (vh - rect.top) / (vh + rect.height);
            const clamped = Math.max(0, Math.min(1, raw));
            const eased = clamped * clamped * (3 - 2 * clamped);
            const centered = eased * 2 - 1;

            item.imageTarget = centered * -62;
            for (let idx = 0; idx < item.cardTargets.length; idx += 1) {
              const amplitude = idx === 3 ? 72 : 58;
              item.cardTargets[idx] = -eased * amplitude;
            }
          });
        },
        render() {
          let hasActiveMotion = false;
          const lerp = (from, to, factor) => from + (to - from) * factor;

          this.items.forEach((item) => {
            item.imageCurrent = lerp(item.imageCurrent, item.imageTarget, 0.12);
            item.section.style.setProperty('--parallax-image-shift', `${item.imageCurrent.toFixed(2)}px`);

            item.cards.forEach((card, idx) => {
              item.cardCurrents[idx] = lerp(item.cardCurrents[idx], item.cardTargets[idx], 0.12);
              card.style.setProperty('--card-parallax-shift', `${item.cardCurrents[idx].toFixed(2)}px`);
            });

            const imageDelta = Math.abs(item.imageTarget - item.imageCurrent);
            const cardsDelta = item.cardTargets.reduce((max, target, idx) => {
              return Math.max(max, Math.abs(target - item.cardCurrents[idx]));
            }, 0);
            if (Math.max(imageDelta, cardsDelta) > 0.08) hasActiveMotion = true;
          });

          if (hasActiveMotion) this.start();
        },
        start() {
          if (this.rafId) return;
          this.rafId = window.requestAnimationFrame(() => {
            this.rafId = 0;
            this.render();
          });
        },
        request() {
          this.readTargets();
          this.start();
        },
      };
    }

    const state = window.__tathaParallaxV2State;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window) {
      document.querySelectorAll('[data-parallax-v2-section]').forEach((section) => {
        if (section.dataset.parallaxV2RevealBound === 'true') return;

        const cards = section.querySelectorAll('[data-parallax-v2-card]');
        if (!cards.length) return;

        section.dataset.parallaxV2RevealBound = 'true';
        section.classList.add('parallax-v2--reveal-ready');

        const stage = section.querySelector('[data-parallax-v2-stage]') || section;
        const revealAll = () => {
          cards.forEach((card) => card.classList.add('is-visible'));
          window.setTimeout(() => {
            section.classList.add('parallax-v2--reveal-complete');
            state.request();
          }, 620);
        };

        const stageTouchesViewportCenter = (rect) => {
          const vh = window.innerHeight || 600;
          return rect.bottom > 0 && rect.top <= vh * 0.8;
        };

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              revealAll();
              io.disconnect();
            });
          },
          { rootMargin: '0px 0px -20% 0px', threshold: 0 }
        );

        io.observe(stage);

        requestAnimationFrame(() => {
          const rect = stage.getBoundingClientRect();
          if (stageTouchesViewportCenter(rect)) {
            revealAll();
            io.disconnect();
          }
        });
      });
    }

    document.querySelectorAll('[data-parallax-v2-section]').forEach((section) => {
      const cards = Array.from(section.querySelectorAll('[data-parallax-v2-card]'));
      if (!cards.length) return;
      if (state.items.some((item) => item.section === section)) return;

      state.items.push({
        section,
        cards,
        imageCurrent: 0,
        imageTarget: 0,
        cardCurrents: cards.map(() => 0),
        cardTargets: cards.map(() => 0),
      });
    });

    if (prefersReducedMotion) {
      state.items.forEach((item) => {
        item.section.style.setProperty('--parallax-image-shift', '0px');
        item.cards.forEach((card) => card.style.setProperty('--card-parallax-shift', '0px'));
      });
      return;
    }

    if (!state.bound) {
      window.addEventListener('scroll', () => state.request(), { passive: true });
      window.addEventListener('resize', () => state.request());
      document.addEventListener('shopify:section:load', () => state.request());
      state.bound = true;
    }

    state.request();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__tathaParallaxCardsState) {
      window.__tathaParallaxCardsState = {
        bound: false,
        rafId: 0,
        sections: new Map(),
        tabletQuery: window.matchMedia('(max-width: 1439px)'),
        mobileQuery: window.matchMedia('(max-width: 768px)'),
        syncSections() {
          const seen = new Set();
          document.querySelectorAll('.parallax-section').forEach((section) => {
            seen.add(section);
            const shell = section.querySelector('.parallax-mask-shell');
            if (!shell) return;

            const heading = section.querySelector('[data-parallax-cards-heading]');
            const cardsList = section.querySelector('[data-parallax-cards-list]');
            const cards = Array.from(section.querySelectorAll('[data-parallax-card]'));
            const existing = this.sections.get(section);

            if (!existing) {
              this.sections.set(section, {
                shell,
                heading,
                cardsList,
                cards,
                state: {
                  headingCurrent: 0,
                  headingTarget: 0,
                  listCurrent: 0,
                  listTarget: 0,
                  cardCurrents: cards.map(() => 0),
                  cardTargets: cards.map(() => 0),
                },
              });
              return;
            }

            existing.shell = shell;
            existing.heading = heading;
            existing.cardsList = cardsList;
            existing.cards = cards;

            if (existing.state.cardCurrents.length !== cards.length) {
              existing.state.cardCurrents = cards.map(() => 0);
              existing.state.cardTargets = cards.map(() => 0);
            }
          });

          this.sections.forEach((_, section) => {
            if (!seen.has(section) || !section.isConnected) {
              this.sections.delete(section);
            }
          });
        },
        readTargets() {
          const viewportHeight = window.innerHeight || 1;
          const isMobile = this.mobileQuery.matches;
          const isTablet = this.tabletQuery.matches;

          this.syncSections();
          this.sections.forEach((entry, section) => {
            const state = entry.state;

            /* Small screens: no scroll parallax (same breakpoint as @media (max-width: 768px)) */
            if (isMobile) {
              state.headingTarget = 0;
              state.listTarget = 0;
              state.cardTargets.fill(0);
              state.headingCurrent = 0;
              state.listCurrent = 0;
              state.cardCurrents.fill(0);
              return;
            }

            const rect = section.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > viewportHeight) {
              state.headingTarget = 0;
              state.listTarget = 0;
              state.cardTargets.fill(0);
              return;
            }

            const raw = (viewportHeight - rect.top) / (viewportHeight + rect.height);
            const clamped = Math.max(0, Math.min(1, raw));
            // smoother curve (ease-in-out) to mimic premium parallax pacing
            const eased = clamped * clamped * (3 - 2 * clamped);
            const centered = eased * 2 - 1;

            /* Laptop / tablet (769–1439): gentler motion; large desktop: stronger (mobile handled above) */
            /* Keep headline from drifting up into the mask (was -18 / -26) */
            const headingAmp = isTablet && !isMobile ? -12 : -16;
            const listAmp = isTablet && !isMobile ? 12 : 16;
            state.headingTarget = centered * headingAmp;
            state.listTarget = centered * listAmp;

            entry.cards.forEach((_, idx) => {
              const direction = idx % 2 === 0 ? -1 : 1;
              const cardAmp = isTablet && !isMobile ? 12 : 16;
              state.cardTargets[idx] = centered * cardAmp * direction;
            });
          });
        },
        render() {
          let hasActiveMotion = false;

          this.sections.forEach((entry) => {
            const state = entry.state;
            const heading = entry.heading;
            const cardsList = entry.cardsList;
            const cards = entry.cards;
            const lerp = (from, to, factor) => from + (to - from) * factor;

            state.headingCurrent = lerp(state.headingCurrent, state.headingTarget, 0.12);
            state.listCurrent = lerp(state.listCurrent, state.listTarget, 0.12);

            if (heading) {
              heading.style.setProperty('--heading-shift', `${state.headingCurrent.toFixed(2)}px`);
            }

            if (cardsList) {
              cardsList.style.setProperty('--cards-shift', `${state.listCurrent.toFixed(2)}px`);
            }

            cards.forEach((card, idx) => {
              state.cardCurrents[idx] = lerp(state.cardCurrents[idx], state.cardTargets[idx], 0.12);
              card.style.setProperty('--card-shift', `${state.cardCurrents[idx].toFixed(2)}px`);
            });

            const headingDelta = Math.abs(state.headingTarget - state.headingCurrent);
            const listDelta = Math.abs(state.listTarget - state.listCurrent);
            const cardsDelta = state.cardTargets.reduce((max, target, idx) => {
              return Math.max(max, Math.abs(target - state.cardCurrents[idx]));
            }, 0);

            if (Math.max(headingDelta, listDelta, cardsDelta) > 0.08) {
              hasActiveMotion = true;
            }
          });

          if (hasActiveMotion) {
            this.start();
          }
        },
        start() {
          if (this.rafId) return;
          this.rafId = window.requestAnimationFrame(() => {
            this.rafId = 0;
            this.render();
          });
        },
        request() {
          this.readTargets();
          this.start();
        },
      };
    }

    const state = window.__tathaParallaxCardsState;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const bindParallaxSectionCardReveal = () => {
      if (!('IntersectionObserver' in window)) return;

      document.querySelectorAll('.parallax-section').forEach((section) => {
        section.classList.add('parallax-reveal-ready');
        if (section.dataset.parallaxSectionRevealBound === 'true') return;
        const cards = section.querySelectorAll('[data-parallax-card].scroll-reveal');
        if (!cards.length) return;
        section.dataset.parallaxSectionRevealBound = 'true';

        if (prefersReducedMotion) {
          cards.forEach((card) => {
            card.classList.add('is-visible');
          });
          return;
        }

        const revealAll = () => {
          cards.forEach((card) => {
            card.classList.add('is-visible');
          });
        };

        const imageShell = section.querySelector('.parallax-mask-shell');
        const observeTarget = imageShell || section;

        /**
         * Reveal when the image shell reaches ~80% down from top of viewport.
         */
        const imageTouchesViewportCenter = (rect) => {
          const vh = window.innerHeight || 600;
          return rect.bottom > 0 && rect.top <= vh * 0.8;
        };

        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              if (entry.intersectionRect.height < 1) return;
              revealAll();
              io.disconnect();
            });
          },
          {
            root: null,
            rootMargin: '0px 0px -20% 0px',
            threshold: 0,
          }
        );

        io.observe(observeTarget);

        requestAnimationFrame(() => {
          const r = observeTarget.getBoundingClientRect();
          if (imageTouchesViewportCenter(r)) {
            revealAll();
            io.disconnect();
          }
        });
      });
    };

    bindParallaxSectionCardReveal();

    if (prefersReducedMotion) {
      document.querySelectorAll('[data-parallax-cards-heading]').forEach((heading) => {
        heading.style.setProperty('--heading-shift', '0px');
      });
      document.querySelectorAll('[data-parallax-cards-list]').forEach((list) => {
        list.style.setProperty('--cards-shift', '0px');
      });
      document.querySelectorAll('[data-parallax-card]').forEach((card) => {
        card.style.setProperty('--card-shift', '0px');
      });
      state.sections.clear();
      return;
    }

    if (!state.bound) {
      window.addEventListener('scroll', () => state.request(), { passive: true });
      window.addEventListener('resize', () => state.request());
      document.addEventListener('shopify:section:load', () => {
        state.request();
        bindParallaxSectionCardReveal();
      });
      state.bound = true;
    }

    state.request();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["philosophy-frame-1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('.philosophy-frame-1');
    if (!section) return;

    const mq = window.matchMedia('(max-width: 749px)');
    const svgVideo = section.querySelector('.philosophy-frame-1__video--svg');
    const nativeVideo = section.querySelector('.philosophy-frame-1__video--native');

    const syncVideos = () => {
      const useNative = mq.matches;
      if (svgVideo) {
        if (useNative) svgVideo.pause();
        else svgVideo.play().catch(() => {});
      }
      if (nativeVideo) {
        if (useNative) nativeVideo.play().catch(() => {});
        else nativeVideo.pause();
      }
    };

    syncVideos();
    mq.addEventListener('change', syncVideos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initMarquee = (root) => {
      const sectionRoot =
        root && root.matches && root.matches('[data-marquee-section]')
          ? root
          : root && root.querySelector
          ? root.querySelector('[data-marquee-section]')
          : null;
      if (!sectionRoot) return;

      const track = sectionRoot.querySelector('[data-marquee-track]');
      const firstGroup = sectionRoot.querySelector('[data-marquee-group]');
      if (!track || !firstGroup) return;

      const groupWidth = firstGroup.getBoundingClientRect().width;
      if (!groupWidth) return;

      // Keep speed consistent regardless of content length.
      const pxPerSecond = 90;
      const duration = Math.max(groupWidth / pxPerSecond, 12);

      track.style.setProperty('--marquee-distance', `${groupWidth}px`);
      track.style.setProperty('--marquee-duration', `${duration.toFixed(2)}s`);
    };

    const initAll = () => {
      document.querySelectorAll('[data-marquee-section]').forEach((sectionRoot) => {
        initMarquee(sectionRoot);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('resize', initAll);
    document.addEventListener('shopify:section:load', (event) => {
      initMarquee(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["what-makes-us-different"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-different-scroll]');
    if (!sections.length) return;

    const SCROLL_MULTIPLIER = 1.85;
    const TAIL_VH = 0.32;

    const isStackedLayout = () => window.matchMedia('(max-width: 990px)').matches;

    function readLastDescriptionScrollEnd(inner, outer) {
      const cards = inner.querySelectorAll('[data-different-card]');
      if (!cards.length || !outer) return 0;
      const last = cards[cards.length - 1];
      const outerH = outer.clientHeight;
      if (outerH < 1) return 0;
      const lastBottom = last.offsetTop + last.offsetHeight;
      const lineBuffer = 48;
      return Math.max(0, lastBottom - outerH + lineBuffer);
    }

    function isSectionActive(section) {
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      return rect.top < vh * 0.5 && rect.bottom > vh * 0.5;
    }

    function readScrollEndY(section, inner) {
      const outer = section.querySelector('[data-different-cards-outer]');
      const maxTravel = Math.max(0, inner.scrollHeight - (outer ? outer.clientHeight : 0));
      let scrollEndY = readLastDescriptionScrollEnd(inner, outer);
      if (!scrollEndY || scrollEndY < 8) {
        scrollEndY = maxTravel;
      }
      return Math.min(Math.max(0, scrollEndY), maxTravel);
    }

    function measure(section, options) {
      if (isStackedLayout()) {
        section.style.height = 'auto';
        section.dataset.differentTailExtra = '0';
        section.dataset.differentMaxTravel = '0';
        section.dataset.differentScrollEndY = '0';
        section.dataset.differentMeasuredHeight = '0';
        const inner = section.querySelector('[data-different-cards-inner]');
        if (inner) inner.style.transform = '';
        return;
      }

      const inner = section.querySelector('[data-different-cards-inner]');
      if (!inner) return;

      if (options && options.skipWhileActive && isSectionActive(section)) return;

      const scrollEndY = readScrollEndY(section, inner);
      const tailExtra = Math.round(window.innerHeight * TAIL_VH);
      const nextHeight = Math.round(window.innerHeight + scrollEndY * SCROLL_MULTIPLIER + tailExtra);
      const prevHeight = Number(section.dataset.differentMeasuredHeight || 0);

      section.dataset.differentMaxTravel = String(
        Math.max(0, inner.scrollHeight - (section.querySelector('[data-different-cards-outer]')?.clientHeight || 0))
      );
      section.dataset.differentScrollEndY = String(scrollEndY);
      section.dataset.differentTailExtra = String(tailExtra);

      const height =
        prevHeight && isSectionActive(section) ? Math.max(prevHeight, nextHeight) : nextHeight;
      section.style.height = height + 'px';
      section.dataset.differentMeasuredHeight = String(height);
    }

    function applyTransform(section, inner, y) {
      inner.style.transform = 'translate3d(0, ' + y.toFixed(2) + 'px, 0)';
    }

    function update() {
      if (isStackedLayout()) return;

      const vh = window.innerHeight;

      sections.forEach((section) => {
        const inner = section.querySelector('[data-different-cards-inner]');
        if (!inner) return;

        const rect = section.getBoundingClientRect();
        const scrollEndY = Number(section.dataset.differentScrollEndY || 0) || readScrollEndY(section, inner);

        if (rect.bottom <= 0) {
          applyTransform(section, inner, -scrollEndY);
          return;
        }

        if (rect.top >= vh) {
          applyTransform(section, inner, 0);
          return;
        }

        const scrollable = section.offsetHeight - vh;
        if (scrollable <= 0) return;

        const scrolled = Math.max(0, -rect.top);
        const tailExtra = Number(section.dataset.differentTailExtra || 0);
        const cardScrollable = Math.max(1, scrollable - tailExtra);
        const cardProgress = Math.max(0, Math.min(1, scrolled / cardScrollable));
        const targetY = -cardProgress * scrollEndY;

        applyTransform(section, inner, targetY);
      });

      rafId = requestAnimationFrame(update);
    }

    let rafId = 0;
    let measureDebounce = 0;

    function scheduleMeasure(options) {
      window.clearTimeout(measureDebounce);
      measureDebounce = window.setTimeout(() => {
        sections.forEach((section) => measure(section, options));
      }, 80);
    }

    function whenImagesReady(section, callback) {
      const images = section.querySelectorAll('img');
      if (!images.length) {
        callback();
        return;
      }

      let pending = images.length;
      const done = () => {
        pending -= 1;
        if (pending <= 0) callback();
      };

      images.forEach((img) => {
        if (img.complete) done();
        else {
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        }
      });
    }

    function bindResizeObservers() {
      if (typeof ResizeObserver === 'undefined') return;

      sections.forEach((section) => {
        const inner = section.querySelector('[data-different-cards-inner]');
        const outer = section.querySelector('[data-different-cards-outer]');
        if (!inner || inner.dataset.differentRoBound === '1') return;

        inner.dataset.differentRoBound = '1';
        const ro = new ResizeObserver(() => scheduleMeasure({ skipWhileActive: true }));
        ro.observe(inner);
        if (outer && !outer.dataset.differentRoBound) {
          outer.dataset.differentRoBound = '1';
          ro.observe(outer);
        }
      });
    }

    function init() {
      sections.forEach((section) => {
        measure(section);
        whenImagesReady(section, () => scheduleMeasure());
      });
      bindResizeObservers();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => scheduleMeasure({ skipWhileActive: true }));
      }
      if (!rafId) rafId = requestAnimationFrame(update);
    }

    init();
    window.addEventListener('resize', () => scheduleMeasure({ skipWhileActive: true }));
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
